export const copyToClip = async (content: string) => {
	if (navigator.clipboard) {
		await navigator.clipboard.writeText(content);
	} else {
		const element = document.createElement('input');

		element.value = content;
		element.style.visibility = 'hidden';
		document.body.appendChild(element);
		element.select();
		document.execCommand('copy');
		document.body.removeChild(element);
	}

	return Promise.resolve();
};

export const isSafari = () => {
	return /Safari/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent);
}

export const runtimeClient = {
	isAndroid: Boolean(navigator.userAgent.match(/android/ig)), // 是否是Android浏览器
	isMobile: Boolean(/(iPhone|iPad|iPod|iOS|Android|Mobile)/i.test(navigator.userAgent)), // 是否是手机端
	// isDesktop: Boolean(navigator.userAgent.match(/(Electron|Desktop)/ig)), // 是否是Electron端
};

export function formSubmit(action: string, params: object, iframe: any) {
	const doc = iframe.contentWindow.document;
	const form = doc.createElement('form');

	doc.body.appendChild(form);
	form.method = 'post';
	form.action = action.replace(/&amp;/g, '&');
	form.style.display = 'none';
	form.enctype = 'multipart/form-data';

	if (params) {
		Object.entries(params).forEach(([name, value]) => {
			const input = document.createElement('input');

			input.name = name;
			input.value = value;

			form.appendChild(input);
		});
	}

	// form.submit();
}


/**
 * Infer firstname / lastname from email
 * Safe-by-default (B2B friendly)
 */
export function inferNameFromEmail(email: string) {
  if (!email || typeof email !== 'string') return null;

  const atIndex = email.indexOf('@');
  if (atIndex <= 0) return null;

  let local = email.slice(0, atIndex).trim();

	// username
	let username = local
    // remove + alias
    .split('+')[0]
    // keep only [a-z0-9._]
    .replace(/[^A-Za-z0-9._-]/g, '')
    // normalize repeated . _
    // .replace(/[._-]{2,}/g, '.')
    // trim leading/trailing . _
    .replace(/^[._-]+|[._-]+$/g, '')
		.slice(0, 49)
		.toLocaleLowerCase()

  // final sanity check
  if (!username) {
    username = "";
  }

  // 1 remove + alias (gmail-style)
  local = local.split('+')[0];

  // 2️ normalize separators (., _, -)
  local = local.replace(/[._-]+/g, '.');

  // 3️ role-based / system accounts
  const ROLE_BASED = new Set([
    'admin',
    'administrator',
    'support',
    'help',
    'helpdesk',
    'info',
    'contact',
    'sales',
    'marketing',
    'billing',
    'security',
    'noreply',
    'no-reply',
    'robot',
    'bot',
    'team',
    'dev',
    'developer',
    'engineering'
  ]);

  if (ROLE_BASED.has(local)) {
    return {
			username,
		};
  }

  const tokens = local
    .split('.')
    .map(t => t.trim())
    .filter(Boolean);

  // 4️ token count sanity check
  if (tokens.length < 2 || tokens.length > 3) {
    return {
			username,
		};
  }

  // 5 reject tokens with digits
  if (tokens.some(t => /\d/.test(t))) {
    return {
			username,
		};
  }

  // 6 reject very short tokens (e.g. j.d)
  if (tokens.some(t => t.length < 1)) {
    return {
			username,
		};
  }

  // 7️ capitalization helper
  const capitalize = (s: string) =>
    s.charAt(0) + s.slice(1);

  // const firstname = capitalize(tokens[0]);
  // const lastname = capitalize(tokens[tokens.length - 1]);

	const firstname = tokens[0] || "";
  const lastname = tokens[tokens.length - 1] || "";

  return {
		username,
    firstname,
    lastname,
  };
}

export function isSAWDomain() {
  return /shield\.splashtop\.\w+/.test(location.host);
}

export function isSIAPlan(plan_type: string) {
	return /^!?SIA/.test(plan_type);
}

export function isSAWPlan(plan_type: string) {
	return /^!?SAW/.test(plan_type);
}
